// extracted by mini-css-extract-plugin
export default {"cartPopup":"CartPage_cartPopup__q1q93","cartText":"CartPage_cartText__+fBSr","noteText":"CartPage_noteText__E8VW0","orderButton":"CartPage_orderButton__ikqjU"};